<template>
  <div class="w-full relative bg-gray-light h-2 my-4 rounded">
    <div class="h-full absolute bg-yellow-400 rounded" v-bind:style="{width: `${progress}%`}"></div>
    <span class="absolute bottom-2 text-xs text-gray-DEFAULT font-bold">0</span>
    <span class="absolute bottom-2 left-1/2 transform -translate-x-1/2 text-xs text-gray-DEFAULT font-bold">50</span>
    <span class="absolute bottom-2 right-0 text-xs text-gray-DEFAULT font-bold ">100</span>
    <span class="absolute top-3 right-0 text-xs text-gray-DEFAULT font-bold">%</span>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress:{
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .test {
    bottom: .5rem;
  }

  .test1 {
    top: .6rem;
  }
</style>
